import React from 'react';
import { Box, chakra } from '@stockx/ui';

export const StyledSwitcher = chakra(Box, {
  baseStyle: {
    backgroundColor: 'beige.100',
    justifyContent: 'space-between',
    overflowX: 'auto',
    margin: 0,
    padding: 0,
    display: 'flex',
    paddingLeft: { base: 1, md: 'initial' },
    paddingRight: { base: 1, md: 'initial' },
    borderBottom: { base: '1px', md: 'initial' },
    borderBottomColor: 'neutral.300',
  },
  label: 'StyledSwitcher',
});

export const StyledSwitcherWrapper = chakra('ul', {
  baseStyle: {
    display: 'flex',
    listStyle: 'none',
    width: '1296px',
    height: '48px',
    justifyContent: 'center',
    margin: { base: 'auto', md: '0 1rem', lg: 'auto' },
    ' li > ul': {
      display: 'none',
    },
    ' li:hover > ul': {
      display: 'block',
    },
  },
  label: 'StyledSwitcherWrapper',
});

export const CategoryLinkStyles = chakra(
  ({ children, onClick, updatedVertical, to, ...rest }) => (
    <li {...rest}>{children}</li>
  ),
  {
    baseStyle: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'suisseIntlMedium',
      boxShadow: 'inset 0 -5px 0 0 transparent',
      textTransform: 'capitalize',
      fontSize: { base: '16px', lg: '18px' },
      color: 'neutral.black',
      whiteSpace: 'nowrap',
      '> a': {
        margin: { base: '0 8px', md: '0 16px' },
        display: 'flex',
        alignItems: 'center',
      },
      _hover: {
        color: 'neutral.black',
      },
      _focus: {
        color: 'neutral.black',
      },
    },
    label: 'CategoryLinkStyles',
  },
);
